import React, {Component} from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {Grid, Button, Popup, Header} from "semantic-ui-react";
import CircuitName from "./CircuitName";
import UserName from "./Card";
import AdSense from 'react-adsense';

class ShowOff extends Component {
    render() {
        return(
        <Grid columns={12} stackable={false}
              style={{minHeight: 60, paddingTop: 2, backgroundColor: '#eeeeee', paddingLeft: 15}}>
            {this.props.show_ads &&
            <Grid.Column width={2} key='adsense' style={{padding: 2}}>
                <AdSense.Google
                    client='ca-pub-4274068129397983'
                    slot='1035864869'
                    style={{ width: 200, height: 70, float: 'left' }}
                    format=''
                />
            </Grid.Column>
            }
            {this.props.featured_experiments.map((experiment, index)=>
                index < 10 && <Grid.Column key={index} style={{padding: 2}}>
                    <Popup
                           position={index == 0 ? 'bottom left' : 'bottom center'}
                           hoverable
                           flowing
                           pinned={true}
                           trigger={
                        <Button href={experiment.url} target='_blank' style={{padding: 3}}>
                            <LazyLoadImage
                                onError={(event) => event.target.src = ''}
                                alt={experiment.alt}
                                height={65}
                                src={experiment.thumbnail_url} // use normal <img> attributes as props
                                width={95} />
                        </Button>
                    }>


                    <a href={experiment.url} target='_blank'><h4>{experiment.name}</h4></a>

                    <UserName hide_joint_at={false} width={400} color='#00000' creator={experiment.creator}/>

                    </Popup>
                </Grid.Column>
            )
            }
        </Grid>
        )
    }
}

export default ShowOff;
